import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { List, Map } from "immutable";
import { components } from "griddle-react";

import { Album } from "../../models";

interface Props {
    albums: Album[];
}

export const AlbumsList = ({ albums }: Props) => {
    const albumTitles: Array<JSX.Element | string> = [];
    if (albums != null) {
        for (const album of albums) {
            const albumUrl = album.getViewUrl();
            if (albumUrl != null) {
                albumTitles.push(<Link key={album.id} to={albumUrl}>{album.getTitle()}</Link>);
            }
            else {
                albumTitles.push(album.getTitle());
            }
        }
    }
    return (
        <span className="albums-list">
            {_.reduce(albumTitles,
                (result, album) => result.length === 0 ? [album] : [...result, ", ", album],
            [])}
        </span>
    );
};

export const CellAlbumsList = ({ value }: components.CellProps) => {
    let albums: Album[] = value;
    if (value != null && !Array.isArray(value)) {
        const list = value as List<Map<string, any>>;
        albums = _.map(list.toArray(), (map) => new Album(map.toObject()));
    }
    return <AlbumsList albums={albums} />;
};
